import {
  MainContentArea,
  ContentHeader,
  Button,
  DataMappingIcon,
} from "melco-ui";
import { useNavigate, useParams } from "react-router-dom";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { useInputFormat } from "../../hooks/inputFormats/useInputFormat";
import { InputFormatDetailForm } from "../../components/inputFormats/InputFormatDetailForm";
import { useTranslation } from "react-i18next";
import { InputFormatMoreActionButton } from "../../components/inputFormats/InputFormatMoreActionButton";
import { HeaderButtonArea } from "melco-shared-logic";

export const InputFormatDetails: React.FC = () => {
  const { t } = useTranslation();

  const breadcrumb = useBreadcrumb("inputFormats");

  const navigate = useNavigate();

  const { inputFormatId } = useParams<{
    inputFormatId: string;
  }>();

  const { data: inputFormat } = useInputFormat(inputFormatId!);

  const manageDataMappingLink = `/input-formats/${inputFormatId}/data-mappings`;

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={inputFormat?.display_name ?? ""}
          breadcrumb={breadcrumb}
          extra={
            <>
              <Button
                icon={<DataMappingIcon />}
                href={manageDataMappingLink}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  navigate(manageDataMappingLink);
                }}
              >
                {t("dataMappings.actions.manage.button")}
              </Button>
              <HeaderButtonArea />
              {inputFormat && (
                <InputFormatMoreActionButton inputFormat={inputFormat} />
              )}
            </>
          }
        />
      }
      contentPadding
    >
      {inputFormat && <InputFormatDetailForm inputFormat={inputFormat} />}
    </MainContentArea>
  );
};
